"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createElement;
var _react = _interopRequireDefault(require("react"));
var _camelCase = _interopRequireDefault(require("./camelCase"));
var _constants = require("./constants");
var _ariaRefHelpers2 = _interopRequireDefault(require("./ariaRefHelpers"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function createElement(name) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  function isSeismicComponent(name) {
    return typeof name === 'string' && name.indexOf('-') !== -1;
  }
  function isAttribute(name) {
    return _constants.ATTRIBUTES.indexOf(name) !== -1 || name.startsWith('aria-') || name.startsWith('data-');
  }
  function isMappedToProps(name) {
    return _constants.MAPPED_TO_PROPS.indexOf(name) !== -1;
  }
  var _ariaRefHelpers = (0, _ariaRefHelpers2.default)(name, props),
    handleAriaAccessibility = _ariaRefHelpers.handleAriaAccessibility,
    ariaSetVnode = _ariaRefHelpers.ariaSetVnode,
    requiresRef = _ariaRefHelpers.requiresRef;
  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }
  if (props && !!Object.keys(props).length && isSeismicComponent(name)) {
    var existingRef = props.ref && typeof props.ref === 'function' && props.ref;
    var attributes = {};
    var properties = {};
    for (var _name in props) {
      if (isAttribute(_name)) attributes[_name] = props[_name];else properties[(0, _camelCase.default)(_name)] = props[_name];
      if (isMappedToProps(_name)) properties[_name] = props[_name];
    }
    if (!!Object.keys(properties).length) {
      var vnode = _react.default.createElement.apply(_react.default, [name, Object.assign({}, attributes, {
        ref: function ref(node) {
          handleAriaAccessibility(node);
          if (!node) return;
          existingRef && existingRef(node);
          Object.assign(node, properties);
        }
      })].concat(children));
      ariaSetVnode(vnode);
      return vnode;
    }
  }
  if (requiresRef) {
    var _vnode = _react.default.createElement.apply(_react.default, [name, _objectSpread({}, props, {
      ref: function ref(node) {
        handleAriaAccessibility(node);
        if (props && props.ref) {
          props.ref(node);
        }
      }
    })].concat(children));
    ariaSetVnode(_vnode);
    return _vnode;
  } else {
    return _react.default.createElement.apply(_react.default, [name, props].concat(children));
  }
}